export const GET_USER_PRODUCT_PROFILE = 'GET_USER_PRODUCT_PROFILE';
export const EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING = 'EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING';
export const EDIT_USER_PRODUCT_PROFILE_FIELD = 'EDIT_USER_PRODUCT_PROFILE_FIELD';
export const CLEAR_STORES = 'CLEAR_STORES';
export const CLEAR_USER_PRODUCT_STORE = 'CLEAR_USER_PRODUCT_STORE';
export const LOG_OUT = 'LOG_OUT';
export const PROFILE_IMAGE_CHANGED = 'PROFILE_IMAGE_CHANGED';
export const DELETE_COVER_IMAGE_FROM_PRODUCT ='DELETE_COVER_IMAGE_FROM_PRODUCT';



// WEBPACK FOOTER //
// ./src/app/stores/profile/product/product-constants.js